module.exports = __webpack_public_path__ + "images/FUSA_icons/085-trolley-1.0208525be1e36a1653b7168190dd8d7b.svg";